export function run() {
  const containers = document.querySelectorAll("[data-controller=RequireCheckbox]")

  containers.forEach((container) => runInstance(container))
}

function runInstance(container) {
  const minimumRequired = parseInt(container.dataset.requireCheckboxMinimumCount, 10)

  const checkboxTargets = container.querySelectorAll("[data-target=required-checkbox]")
  const submitButtonTarget = container.querySelector("[data-target=submit-button]")

  function getCheckedCount() {
    return Array.from(checkboxTargets).filter((t) => t.checked).length
  }

  function handleChange() {
    const checkedCount = getCheckedCount()
    const enoughChecked = checkedCount >= minimumRequired

    submitButtonTarget.disabled = !enoughChecked
  }

  checkboxTargets.forEach((checkbox) => {
    checkbox.addEventListener("change", handleChange)
  })

  handleChange()
}
